import { StyleSheet, View } from 'react-native';

import { Skeleton } from 'components/ui/skeleton';
import { primitive } from 'styles/constants';

import { CrownIcon } from './components/crown-icon';
import { styles as expirationWarningStyles } from './components/expiration-warning';
import { styles as redeemCardStyles } from './components/redeem-card';
import { styles as profileCardStyles } from './profile-card.styles';

export const ProfileCardSkeleton = () => {
  return (
    <>
      <View style={profileCardStyles.mainCard}>
        <CrownIcon />
        <View style={profileCardStyles.progressContainer}>
          <Skeleton shape="rectangle" style={{ height: 16, marginTop: 12, marginHorizontal: 0 }} />
          <Skeleton
            shape="rectangle"
            style={{
              height: 30,
              width: 100,
              marginVertical: 3,
              marginHorizontal: 0,
              alignSelf: 'center',
            }}
          />
          <Skeleton
            shape="rectangle"
            style={{
              height: 14,
              width: 200,
              alignSelf: 'center',
              marginVertical: 3,
              marginHorizontal: 0,
            }}
          />
          <View style={styles.milestonesContainer}>
            {Array.from({ length: 4 }).map((_, index) => (
              <Skeleton
                shape="rectangle"
                style={{ height: 12, width: 30, marginVertical: 0 }}
                key={index}
              />
            ))}
          </View>
          <Skeleton shape="rectangle" style={{ height: 16, marginVertical: 0 }} />
          <Skeleton
            shape="rectangle"
            style={{ height: 12, width: '60%', marginVertical: 0, marginTop: 6 }}
          />
        </View>

        {/* Expiration Warning */}
        <View style={expirationWarningStyles.expirationWarning}>
          <Skeleton shape="rectangle" style={{ height: 12, width: '70%', marginVertical: 3 }} />
        </View>
      </View>

      {/* Redeem Card */}
      <View style={redeemCardStyles.redeemCard}>
        <View
          style={[
            redeemCardStyles.redeemTextContainer,
            {
              flexDirection: 'row',
            },
          ]}
        >
          <View style={{ flexGrow: 1 }}>
            <Skeleton
              shape="rectangle"
              style={{ height: 12, width: '70%', marginBottom: 0, marginTop: 6 }}
            />
            <Skeleton
              shape="rectangle"
              style={{ height: 12, width: '60%', marginBottom: 0, marginTop: 6 }}
            />
          </View>
          <Skeleton
            shape="rectangle"
            style={{
              height: 30,
              width: 101,
              marginVertical: 3,
              backgroundColor: primitive.$meltyYellow,
              borderRadius: 50,
            }}
          />
        </View>
      </View>

      {/* Bottom Links */}
      <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 18 }}>
        <Skeleton
          shape="rectangle"
          style={{
            height: 14,
            width: 80,
            alignSelf: 'center',
            marginVertical: 3,
            marginHorizontal: 0,
          }}
        />
        <Skeleton
          shape="rectangle"
          style={{
            height: 14,
            width: 80,
            alignSelf: 'center',
            marginVertical: 3,
            marginHorizontal: 0,
          }}
        />
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  milestonesContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 18,
    marginBottom: 4,
  },
});
